<template>
    <div class="_menu" :class="[{pc: !mobile}, {mb: mobile}]">
        <!-- Title -->
        <div class="top">
            <div class="title">
                {{$t('read.catalogue')}}
            </div>

            <!-- Progess -->
            <el-progress class="nqtLearnPercent" :text-inside="true" :stroke-width="$CONST.MENU.MAX_WIDTH_STROKE_PROGESS" :percentage="Math.abs(percent) > $CONST.MENU.MAX_PERCENT ? $CONST.MENU.MAX_PERCENT : Math.abs(percent)"></el-progress>

            <!-- Title -->
            <div class="note-top">
                <div class="text">
                    <!-- <template v-if="!mobile"> -->
                        <span class="dot dot--undone"></span>
                        <span>{{$t('week.undone')}}</span>
                        <span class="dot dot--studing"></span>
                        <span>{{$t('week.studing')}}</span>
                        <span class="dot dot--done"></span>
                        <span>{{$t('week.done')}}</span>
                    <!-- </template> -->
                </div>
                <div class="action">
                    <div class="btn-exc">
                        {{$t('week.exercise')}}
                    </div>
                    <div class="btn-tt">
                        {{$t('week.score')}}
                    </div>
                </div>
            </div>
        </div>

        <!-- Content -->
        <ul class="tree" id="menu" v-show="!loading">
            <li v-for="(itemLv1, indexLv1) in menu" class="ls_content" :key="indexLv1">
                <div class="ls_content_child">
                    <div class="text" @click="jumpToLesson(itemLv1)">
                        <img :src="itemLv1.img"/>
                        <span>{{ itemLv1.chapterName }}</span>
                    </div>
                    <div class="action" v-if="itemLv1.examFlag == 1">
                        <div class="btn-exc" @click="jumpToExercise(itemLv1)">
                            <img :src="itemLv1.examImg"/>
                        </div>
                        <div class="btn-tt" @click="jumpTaskResult(itemLv1)">
                            <span :class="{score: itemLv1.scoreFlag == 1}">
                                {{ itemLv1.scoreStr }}
                            </span>
                        </div>
                    </div>
                    <div class="action" v-if="itemLv1.isExercise == 0 && itemLv1.learningState != null">
                        <div class="btn-exc">
                            <span>
                                {{ itemLv1.default }}
                            </span>
                        </div>
                        <div class="btn-tt">
                            <span>
                                {{ itemLv1.default }}
                            </span>
                        </div>
                    </div>
                </div>
                <ul v-if="itemLv1.childFlag == 1">
                    <li v-for="(itemLv2, indexLv2) in itemLv1.childrens" class="ls_content" :key="indexLv2">
                        <div class="ls_content_child">
                            <div class="text" @click="jumpToLesson(itemLv2)">
                                <img :src="itemLv2.img"/>
                                <span>{{ itemLv2.chapterName }}</span>
                            </div>
                            <div class="action" v-if="itemLv2.examFlag == 1">
                                <div class="btn-exc" @click="jumpToExercise(itemLv2)">
                                    <img :src="itemLv2.examImg"/>
                                </div>
                                <div class="btn-tt" @click="jumpTaskResult(itemLv2)">
                                    <span :class="{score: itemLv2.scoreFlag == 1}">
                                        {{ itemLv2.scoreStr }}
                                    </span>
                                </div>
                            </div>
                            <div class="action" v-if="itemLv2.isExercise == 0 && itemLv2.learningState != null">
                                <div class="btn-exc">
                                    <span>
                                        {{ itemLv2.default }}
                                    </span>
                                </div>
                                <div class="btn-tt">
                                    <span>
                                        {{ itemLv2.default }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <ul v-if="itemLv2.childFlag == 1">
                            <li v-for="(itemLv3, indexLv3) in itemLv2.childrens" class="ls_content" :key="indexLv3">
                                <div class="ls_content_child">
                                    <div class="text" @click="jumpToLesson(itemLv3)">
                                        <img :src="itemLv3.img"/>
                                        <span>{{ itemLv3.chapterName }}</span>
                                    </div>
                                    <div class="action" v-if="itemLv3.examFlag == 1">
                                        <div class="btn-exc" @click="jumpToExercise(itemLv3)">
                                            <img :src="itemLv3.examImg"/>
                                        </div>
                                        <div class="btn-tt" @click="jumpTaskResult(itemLv3)">
                                            <span :class="{score: itemLv3.scoreFlag == 1}">
                                                {{ itemLv3.scoreStr }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="action" v-if="itemLv3.isExercise == 0 && itemLv3.learningState != null">
                                        <div class="btn-exc">
                                            <span>
                                                {{ itemLv3.default }}
                                            </span>
                                        </div>
                                        <div class="btn-tt">
                                            <span>
                                                {{ itemLv3.default }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <ul v-if="itemLv3.childFlag == 1">
                                    <li v-for="(itemLv4, indexLv4) in itemLv3.childrens" class="ls_content" :key="indexLv4">
                                        <div class="ls_content_child">
                                            <div class="text" @click="jumpToLesson(itemLv4)">
                                                <img :src="itemLv4.img"/>
                                                <span>{{ itemLv4.chapterName }}</span>
                                            </div>
                                            <div class="action" v-if="itemLv4.examFlag == 1">
                                                <div class="btn-exc" @click="jumpToExercise(itemLv4)">
                                                    <img :src="itemLv4.examImg"/>
                                                </div>
                                                <div class="btn-tt" @click="jumpTaskResult(itemLv4)">
                                                    <span :class="{score: itemLv4.scoreFlag == 1}">
                                                        {{ itemLv4.scoreStr }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="action" v-if="itemLv4.isExercise == 0 && itemLv4.learningState != null">
                                                <div class="btn-exc">
                                                    <span>
                                                        {{ itemLv4.default }}
                                                    </span>
                                                </div>
                                                <div class="btn-tt">
                                                    <span>
                                                        {{ itemLv4.default }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <ul v-if="itemLv4.childFlag == 1">
                                            <li v-for="(itemLv5, indexLv5) in itemLv4.childrens" class="ls_content" :key="indexLv5">
                                                <div class="ls_content_child">
                                                    <div class="text" @click="jumpToLesson(itemLv5)">
                                                        <img :src="itemLv5.img"/>
                                                        <span>{{ itemLv5.chapterName }}</span>
                                                    </div>
                                                    <div class="action" v-if="itemLv5.examFlag == 1">
                                                        <div class="btn-exc" @click="jumpToExercise(itemLv5)">
                                                            <img :src="itemLv5.examImg"/>
                                                        </div>
                                                        <div class="btn-tt" @click="jumpTaskResult(itemLv5)">
                                                            <span :class="{score: itemLv5.scoreFlag == 1}">
                                                                {{ itemLv5.scoreStr }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="action" v-if="itemLv5.isExercise == 0 && itemLv5.learningState != null">
                                                        <div class="btn-exc">
                                                            <span>
                                                                {{ itemLv5.default }}
                                                            </span>
                                                        </div>
                                                        <div class="btn-tt">
                                                            <span>
                                                                {{ itemLv5.default }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>

        <!-- Loading -->
        <loading class="loading--lesson" :showLoading="loadingExc" />
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex"
    import loading from "@/components/loading/loading"
    export default {
        data() {
            return {
                course: {},
                menu: [],
                userId: null,
                percent: 0,
                loading: true,
                loadingExc: false,
                dataCheckExercise: []
            };
        },
        computed: {
            ...mapState({
                mobile: (state) => state.header.mobile,
                activeMenuID: (state) => state.learn.activeID,
            }),
        },
        components: {
            loading
        },
        updated() {
            var tree = document.getElementById("menu");
            if (tree) {
                tree.querySelectorAll(".ls_content_child").forEach(function (el, key, parent) {
                    var elm = el.parentNode;

                    el.addEventListener("click", function (event) {
                        if (elm.classList.contains("collapse")) {
                            elm.classList.add("expand");
                            elm.classList.remove("collapse");
                        } else {
                            elm.classList.add("collapse");
                            elm.classList.remove("expand");
                        }
                    }, false)
                })
            }
        },
        methods: {
            init: async function (params) {
				this.course.name = params.courseName;
				this.course.id = params.courseId;
				this.userId = params.userId;

                // percent
                this.percent = await this.getCourseProcess({courseId: params.courseId});

                // Get data menu
                let results = await this.getMenu({courseId: params.courseId});

                // Data for check exercise befor start final exam
                this.dataCheckExercise = results;

                this.menu = this.convertDataMenu(results);

                this.setActiveID(null);

                this.loading = false;
            },

            // Get data menu
            getMenu: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseSubOutlineListByTopOutline", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Convert data
            convertDataMenu: function (data) {
                const self = this;
                let results = [];

                data.forEach((item) => {
                    // Set status lesson
                    item = self.getStatusLesson(item);
                    item.childFlag = 0;

                    let keyParent = data.findIndex((x) => x.id == item.parentId);
                    if (keyParent >= 0) {
                        data[keyParent].childrens = data[keyParent].childrens == null ? [] : data[keyParent].childrens;
                        data[keyParent].childFlag = 1;
                        data[keyParent]['img'] = "../../../static/images/folder-e.png";
                        data[keyParent].childrens.push(item);
                    }
                });

                results = data.filter((x) => {
                    return x.level == 1;
                });

                return results;
            },

            // Get status learn lesson
            getStatusLesson: function (item) {
                let src = "../../../static/images/baihoc-den.png";

                let score = 0;

                item['status'] = 0;

                if (item.score == "—") {
                    if (item.isExercise == 0) {
                        score = 100;
                    }
                } else {
                    score = parseInt(item.score) || 0;
                }

                if (item.learningState == this.$CONST.VIDEO.MENU.LEARNING) {
                    src = "../../../static/images/baihoc-do.png";
                    item['status'] = 1;
                }

                if (item.learningState == this.$CONST.MENU.LEARNING_COMPLETED && parseInt(item.passingRateQuiz) > score && parseInt(item.isExercise) > 0) {
                    src = "../../../static/images/baihoc-do.png";
                    item['status'] = 1;
                }

                if (item.learningState == this.$CONST.VIDEO.MENU.LEARNING_COMPLETED && item.score == "—" && parseInt(item.questionStatus) == 0 && parseInt(item.isExercise) == 0) {
                    src = "../../../static/images/baihoc-xanhla.png";
                    item['status'] = 2;
                }

                if (item.learningState == this.$CONST.VIDEO.MENU.LEARNING_COMPLETED && parseInt(item.passingRateQuiz) <= score && parseInt(item.questionStatus) == 1 && parseInt(item.isExercise) > 0) {
                    src = "../../../static/images/baihoc-xanhla.png";
                    item['status'] = 2;
                }

                if (item.learningState == this.$CONST.VIDEO.MENU.LEARNING_COMPLETED && parseInt(item.passingRateQuiz) == 0) {
                    src = "../../../static/images/baihoc-xanhla.png";
                    item['status'] = 2;
                }

                if (item.score == "—") {
                    if (item.isExercise == 0) {
                        item["scoreNew"] = 100;
                    } else {
                        item["scoreNew"] = 0;
                    }
                } else {
                    item["scoreNew"] = parseInt(item.score);
                }

                // Exam

                item["examType"] = null;
                item["examImg"] = null;

                if (item.isExercise != this.$CONST.MENU.EXERCISE_NONE) {
                    item["examFlag"] = 1;

                    if (parseInt(item.questionStatus) == 0) {
                        item["examType"] = 1;
                        item["examImg"] = "../../../static/images/baitap-den.png";
                    }

                    if (parseInt(item.questionStatus) == 2) {
                        item["examType"] = 2;
                        item["examImg"] = "../../../static/images/baitap-do.png";
                    }

                    if (parseInt(item.questionStatus) == 1 && parseInt(item.passingRateQuiz) > score) {
                        item["examType"] = 2;
                        item["examImg"] = "../../../static/images/baitap-do.png";
                    }

                    if (parseInt(item.questionStatus) == 1 && parseInt(item.passingRateQuiz) <= score) {
                        item["examType"] = 0;
                        item["examImg"] = "../../../static/images/baitap-xanhla.png";
                    }
                } else {
                    item["examFlag"] = 0;
                }

                // Score
                if (item.score != '—') {
                    item["scoreFlag"] = 1;
                    item["scoreStr"] = `${item.score}%`;
                } else {
                    item["scoreFlag"] = 0;
                    item["scoreStr"] = `—`;
                }

                if (item.learningState == null) {
                    src = "../../../static/images/folder-e.png";
                }

                item['img'] = src;
                item["default"] = `—`;

                return item;
            },

            getMaterial: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseMaterialNew", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            getCourseProcess: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("//courseStudy/getCourseProcess", params)
                        .then((response) => {
                            resolve(Number(response.data));
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },


            // Go to lesson
            jumpToLesson: async function (lesson) {
                // Check childFlag
                if (lesson.childFlag == 1) return;

                let err = false;

                // Call api
                // Check No information
                let material = await this.getMaterial({courseOutlineId: lesson.id, languageType: this.$lang()}).catch((error) => {
                    this.$message.warning(this.$i18n.t("js.dataNone"));
                    err = true;
                });

                if (err) return;

                if (material.materialList == null || material.materialList.length == 0) {
                    this.$message.warning(this.$i18n.t("js.dataNone"));
                    return;              
                }

                // Jump to Lesson
                this.$router.push({
                    path: "/home/curriculum/lesson",
                    query: {
                        outlineInfo: JSON.stringify({
                            courseId: this.course.id,
                            courseName: this.course.name,
                            activeID: lesson.id,
                            redirectType: 0
                        }),
                    },
                });

            },

            ...mapMutations("learn", ["setActiveID"]),

            jumpTaskResult: function (lesson) {
                // Check score
                if (lesson.scoreFlag == 0) return;

                this.$router.push({
                    path: "task/result",
                    query: {
                        outlineInfo: JSON.stringify({
                            courseId: this.course.id,
                            courseName: this.course.name,
                            courseOutlineId: lesson.id
                        }),
                    },
                });
            },

            convert: function (data) {
                var contents = [];
                if (data.materialList != null && data.materialList.length) {
                    contents = data.materialList.reduce((a, v) => {
                        let firstPage = v.num == v.mnum || v.num == 0 ? 1 : v.num;
                        let path = Number(v.materialType) == 3 ? v.materialPath : null;
                        a.push({
                            id: v.id,
                            type: Number(v.materialType),
                            path: path,
                            mnum: v.mnum,
                            no: v.no,
                            num: firstPage,
                            currentNum: v.num,
                            learningState: v.learningState,
                            exerciseState: v.exerciseState,
                            isExercise: v.isExercise
                        });
                        return a;
                    }, []);
                }

                return {
                    id: data.courseOutlineId,
                    nextId: data.nextOutlineId,
                    prevId: data.preOutlineId,
                    contents: contents
                };
            },

            jumpToExercise: async function (lesson) {

                this.loadingExc = true;
                let dataNone = false;

                let material = await this.getMaterial({courseOutlineId: lesson.id, languageType: this.$lang()}).catch((error) => {
                    dataNone = true;
                });

                this.loadingExc = false;

                if (!dataNone) {
                    let data = this.convert(material);

                    // You cannot do the excercise because you haven't complete the content.
                    if (data.contents != null && data.contents.some(item => item.learningState != 0)) {
                        this.$message.warning(window.vm.$i18n.t('new.title104'));
                        return;
                    }
                }

                if (parseInt(lesson.questionStatus) == 2) {
                    this.$message.warning(window.vm.$i18n.t('new.title27'));
                    return;
                }

                // Jump to exercise
                this.$router.push({
                    path: "/home/task/answer",
                    query: {
                        outlineInfo: JSON.stringify({
                            courseId: this.course.id,
                            courseName: this.course.name,
                            courseOutlineId: lesson.id,
                            chapterName: lesson.chapterName
                        }),
                    },
                });
            },

        },
    };
</script>
<style scoped>
    .nqtLearnPercent {
        height: 30px;
        padding: 0 26px;
    }
    .dot {
        margin-left: 5px;
        margin-right: 0;
    }
    ._menu.mb .dot {
        height: 12px;
    }
    .dot--studing {
        background-color: red;
    }
    ._menu .top {
        height: 100px;
    }
    ._menu {
        position: relative;
        padding-top: 10px;
        overflow: auto;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.45);
        border-radius: 10px;
    }
    .loading {
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: rgb(38 50 56 / 0%);
        transform: translate(-50%, -50%);
    }
    .ls_content span.active, .ls_content span:hover {
        color: #1e90ff;
    }
    .ls_content img{
        width: 24px;
        height: 18px;
        margin-top: 2px;
        margin-left: 6px;
        float: left;
    }
    .ls_content {
        margin-bottom: 1.5em;
    }
    .ls_content_child {
        display: flex;
    }
    ._menu.pc .ls_content_child .text {
        width: calc(100% - 200px);
    }
    ._menu.pc .ls_content_child .action {
        width: 200px;
    }
    ._menu.mb .ls_content_child .text {
        width: calc(100% - 120px);
    }
    ._menu.mb .ls_content_child .action {
        width: 120px;
    }
    .ls_content_child .action {
        display: flex;
    }
    .ls_content_child .action div{
        width: 50%;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .ls_content_child .action .score {
        background: #0071c5;
        color: #fff;
        border-radius: 4px;
        font-size: 10px;
        cursor: pointer;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .ls_content_child .action img {
        margin: auto;
    }
    .top .title {
        height: 40px;
        font-size: 24px;
        text-align: Center;
        color: #0071c5;
        text-transform: uppercase;
    }
    .note-top {
        display: flex;
        height: 30px;
        padding: 0 10px;
    }
    .note-top .text {
        padding-left: 16px;
        display: flex;
        align-items: center;
    }
    .note-top .text span {
        padding-left: 5px;
    }
    ._menu.pc {
        min-height: calc(100vh - 290px);
    }
    ._menu.mb {
        min-height: calc(100vh - 220px);
    }
    ._menu.pc .note-top .text {
        width: calc(100% - 200px);
    }
    ._menu.pc .note-top .action {
        width: 200px;
    }
    ._menu.mb .note-top .text {
        width: calc(100% - 120px);
    }
    ._menu.mb .note-top .action {
        width: 120px;
    }
    .note-top .action {
        display: flex;
    }
    .note-top .action div{
        width: 50%;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .ls_content ul {
        margin-top: 1.5em;
    }
    .ls_content span {
        width: max-content;
        font-size: 14px;
        font-weight: normal;
        color: #000;
        font-family: Arial !important;
    }
    .tree {
        margin: 0 10px;
        padding: 0;
        list-style: none;
        cursor: pointer;
        height: calc(100% - 110px);
        padding-top: 10px;
        overflow: auto;
    }
    .tree ul{
        margin: 0;
        padding: 0;
        list-style: none;
        margin-left: 1.3em;
        position: relative;
    }
    .tree ul ul{
        margin-left: .5em;
    }
    .tree ul::before{
        content: "";
        display: block;
        width: 0;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        border-left: 1px solid;
        border-color: #3b475033;
    }
    .tree ul li::before{
        content: "";
        display: block;
        width: 15px;
        height: 0;
        border-top: 1px solid;
        border-color: #3b475033;
        margin-top: -1px;
        position: absolute;
        top: 1.2em;
        left: 0;
    }
    .tree ul li::last-child::before{
        background: #fff;
        height: auto;
        top: 1.5em;
        bottom: 0;
    }
    .tree li{
        margin: 0;
        padding: 0.2em 1.2em;
        padding-right: 0;
        line-height: 2em;
        color: #3b475033;
        font-weight: 700;
        position: relative;
    }
    .ls_content.expand ul {
        display: block;
    }
    .ls_content.collapse ul{
        display: none;
    }
    li span{
        color: gray;
        padding-left: 5px;
    }
    .indicator {
        margin-right: 5px;
    }
    .branch {
        display: block !important;
    }
    ::-webkit-scrollbar {
        cursor: pointer;
    }

    ::-webkit-scrollbar-thumb:horizontal {
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }
    ::-webkit-scrollbar-thumb:vertical {
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }
</style>



// WEBPACK FOOTER //
// src/components/curriculum/menu.vue